export default "__VITE_ASSET__xpzEwZSy__"